import React from "react";
import { useCopies } from "shared/hooks/useCopies";
import I18n from "shared/types/I18n";

export interface TranslationInput {
  name: keyof I18n;
}
function Translation(props: TranslationInput) {
  const copies = useCopies();
  return <React.Fragment>{copies.get(props.name)}</React.Fragment>;
}

export default Translation;
